/* eslint-disable no-nested-ternary */
/* eslint-disable no-case-declarations */
/* eslint-disable no-unused-vars */
import ReactGA from 'react-ga4';
import React, { useEffect, useState } from 'react';

// css
import './external-vehicles.scss';

import { ReactComponent as AddCircle } from 'design_system/src/static/icons/add-circle.svg';
import { ReactComponent as Pin } from 'design_system/src/static/icons/pin.svg';
import { ReactComponent as GPS } from 'design_system/src/static/icons/gps.svg';
import { LightTooltip } from 'components/hocs/tooltip/Tooltip';
import { getGenericMotoImageUrl } from 'models/upload/publicStorage';

import {
	Typography,
	Button,
	Pager,
	DateSelect,
	Select,
	ListTable,
} from 'design_system/src';
import { useLocation, useNavigate } from 'react-router-dom';
import {
	getExternalInventoryFilter,
	setExternalInventoryFilter,
} from 'localStorage/filterStorage';
import moment from 'moment';
import motoLoading from 'static/icons/loading_moto.gif';
import { UserFilter } from 'models/ozonio/interfaces/ozonio.interface';
import useFindAllParams from 'hooks/useFindAllParams';
import useDateFilters from 'hooks/useDatesFilters';
import { formatValuesIfNotMaxLength } from 'models/shared/helpers/utils';
import PersonalFiltersSection from 'components/hocs/personalFiltersSection/PersonalFiltersSection';
import { FilterSections } from 'models/ozonio/enums/ozonio.enum';
import {
	ExternalVehicle,
	ExternalVehicleFilterDto,
} from 'models/_external/external-vehicles/interfaces/external-vehicles.interface';
import {
	ExternalVehicleStatusEnum,
	ExternalVehicleStatusValues,
} from 'models/_external/external-vehicles/enums/external-vehicles.enum';
import { fetchExternalVehicles } from 'models/_external/external-vehicles/controllers/external-vehicles.controller';
import SearchBar from '../../../components/hocs/searchBar/searchBar';
import EditExternalVehicle from './edit/EditExternalVehicle';

// eslint-disable-next-line quotes
function ExternalVehicles() {
	const location = useLocation();

	const {
		findAllParams: { data, currentPage, pages, loading, query, count },
		setData,
		setCurrentPage,
		setPages,
		setLoading,
		setQuery,
		setCount,
	} = useFindAllParams<ExternalVehicle, ExternalVehicle>();
	const [isMounted, setIsMounted] = useState(false);

	// -----------------PERSONAL FILTERS STATES------------------- //
	const [openSaveFilter, setOpenSaveFilter] = useState<boolean>(false);
	const [selectedPersonalFilter, setSelectedPersonalFilter] =
		useState<string>('');

	// -----------------FILTERS STATES------------------- //
	const [statusFilter, setStatusFilter] = useState<ExternalVehicleStatusEnum[]>(
		[],
	);
	const { datesFilter, hasDatesFilter, setDatesFilter, setHasDatesFilter } =
		useDateFilters();

	// -----------------PERSONAL FILTERS LOGIC------------------- //

	const changePersonalFilter = (uFilter: UserFilter) => {
		if (uFilter._id !== selectedPersonalFilter) {
			setSelectedPersonalFilter(uFilter._id);
			setStatusFilter(uFilter.values.statusFilter ?? []);
			if (uFilter.values.datesFilter) {
				setDatesFilter({
					...uFilter.values.datesFilter,
					initial: new Date(uFilter.values.datesFilter.initial),
					last: new Date(uFilter.values.datesFilter.last),
				});
				setHasDatesFilter(true);
			} else {
				setHasDatesFilter(false);
			}
		}
	};

	const getActualFilter = () => ({
		statusFilter,
		datesFilter: hasDatesFilter ? datesFilter : undefined,
	});

	const isFiltersModified = () =>
		!!selectedPersonalFilter || (!statusFilter.length && !hasDatesFilter);

	// -----------------MODULE LOGIC ------------------ //
	const requestVehicles = () => {
		setLoading(true);

		const params: ExternalVehicleFilterDto = {
			query,
			page: currentPage,
			status: formatValuesIfNotMaxLength(
				statusFilter,
				Object.keys(ExternalVehicleStatusEnum).length,
			),
		};

		if (datesFilter && hasDatesFilter) {
			params['min'] = moment.utc(datesFilter.initial).format('YYYY-MM-DD');
			params['max'] = moment.utc(datesFilter.last).format('YYYY-MM-DD');
		}

		setCount(0);
		fetchExternalVehicles(params)
			.then((rows) => {
				if (rows) {
					setData(rows.data);
					setPages(rows.pages);
					setCount(rows.count);
					setLoading(false);
				}
			})
			.catch(() => {
				setLoading(false);
				setData([]);
			});
	};
	const [result, setResult] = useState();

	useEffect(() => {
		if (isMounted) {
			if (currentPage === 1) {
				requestVehicles();
			} else {
				setCurrentPage(1);
			}
		}
	}, [isMounted, statusFilter, result, datesFilter, hasDatesFilter]);

	useEffect(() => {
		if (isMounted) {
			requestVehicles();
		}
	}, [currentPage]);

	useEffect(() => {
		ReactGA.event('VIEW_external_inventory', {
			category: 'External',
			label: 'page view to the external vehicles list view',
		});
		const queryParams = new URLSearchParams(location.search);
		const queryStatusFilter = queryParams.get('statusFilter');
		const information = getExternalInventoryFilter();

		if (information.query) {
			setQuery(information.query);
		}
		if (information?.datesFilter) {
			setDatesFilter({
				...information.datesFilter,
				initial: new Date(information.datesFilter.initial),
				last: new Date(information.datesFilter.last),
			});

			setHasDatesFilter(true);
		}
		if (information.selectedPersonalFilter) {
			setSelectedPersonalFilter(information.selectedPersonalFilter);
		}
		if (information.currentPage) {
			setCurrentPage(information.currentPage);
		}
		if (information.statusFilter?.length) {
			setStatusFilter(information.statusFilter);
		} else if (queryStatusFilter) {
			setStatusFilter([queryStatusFilter as ExternalVehicleStatusEnum]);
		} else {
			setStatusFilter([]);
		}

		if (!isMounted) {
			setIsMounted(true);
		}
	}, []);

	useEffect(() => {
		setExternalInventoryFilter({
			statusFilter,
			query,
			currentPage,
			datesFilter: hasDatesFilter ? datesFilter : null,
			selectedPersonalFilter,
		});
	}, [
		statusFilter,
		query,
		currentPage,
		datesFilter,
		hasDatesFilter,
		selectedPersonalFilter,
	]);

	const [openDetails, setOpenDetails] = useState<boolean>(false);
	const [openEdit, setOpenEdit] = useState<boolean>(false);
	const [openTile, setOpenTile] = useState<boolean>(false);
	const [openSuspend, setOpenSuspend] = useState<boolean>(false);
	const [selectedVehicle, setSelectedVehicle] = useState<ExternalVehicle>();

	const handleSearch = (event: any) => {
		event.preventDefault();
		requestVehicles();
	};

	const renderContent = () => {
		return (
			<div className="dim_100_per flex_content_col shadow_hard inner_container bg_neutral_400">
				<div className="flex_header">
					<div className="bg_neutral_0 shadow_hard p_t_xs p_b_md p_x_lg">
						<div className="display_flex flex_gap_sm flex_align_center">
							<Typography scale="heading3" weight="600" textColor="neutral_900">
								Inventario
							</Typography>
							<SearchBar
								handleSearch={handleSearch}
								query={query}
								setQuery={setQuery}
								className="flex_grow_1"
							/>
						</div>
						<div className="display_flex flex_gap_xl m_b_xs">
							<div className="display_flex flex_grow_1 flex_gap_xs">
								<Select
									fixedPlaceholder
									variant="checkbox"
									placeholder="Estado"
									options={Object.keys(ExternalVehicleStatusValues).map(
										(key: any) => ({
											label: (ExternalVehicleStatusValues as any)[key].title,
											value: key,
										}),
									)}
									value={statusFilter}
									onChange={(e: any) => {
										setStatusFilter(e.target.value);
										setSelectedPersonalFilter('');
									}}
								/>
								<DateSelect
									value={datesFilter}
									hasValue={hasDatesFilter}
									placeholder="Fecha de creación"
									setHasValue={setHasDatesFilter}
									setValue={(e: any) => {
										setDatesFilter(e);
										setHasDatesFilter(true);
										setSelectedPersonalFilter('');
									}}
								/>
							</div>
							<div className="display_flex flex_gap_xs flex_grow_0 flex_align_center">
								<Button
									variant="ghost"
									scale="small"
									icon={<Pin />}
									onClick={() => setOpenSaveFilter(true)}
								>
									Fijar filtro
								</Button>
							</div>
						</div>
						<div className="display_flex flex_gap_xl overflow_x_auto p_b_md">
							<PersonalFiltersSection
								section={FilterSections.extVehicleList}
								selectedFilter={selectedPersonalFilter}
								setSelectedFilter={setSelectedPersonalFilter}
								changeFilter={changePersonalFilter}
								isModified={isFiltersModified}
								setStatusPersonalFilter={() => {}}
								getActualFilter={getActualFilter}
								openSaveFilter={openSaveFilter}
								setOpenSaveFilter={setOpenSaveFilter}
								defaultFilters={[]}
							/>
						</div>
					</div>
				</div>

				<div className="flex_body overflow_x_hidden p_x_lg">
					{loading ? (
						<div className="flex_center_col dim_100_per">
							<Typography
								weight="600"
								scale="heading4"
								textColor="neutral_800"
								className="m_b_xs"
							>
								Cargando los vehículos...
							</Typography>
							<img src={motoLoading} alt="" className="h_xxxl" />
						</div>
					) : data?.length ? (
						<ListTable
							data={data}
							canSelect={false}
							rowClassName="br_none"
							hideHeader
							className="m_t_md"
							onRowClick={(row) => {
								setOpenEdit(true);
								setSelectedVehicle(row);
							}}
							cols={[
								{
									label: 'img',
									weight: 0,
									render: (row: ExternalVehicle, index: number) => (
										<div className="external_vehicle_list_img" key={index}>
											<img
												className="img dim_100_per"
												src={
													row.image ? row.image.url : getGenericMotoImageUrl()
												}
												alt="vehicle"
											/>
										</div>
									),
								},
								{
									label: 'name',
									weight: 1,
									render: (row: ExternalVehicle, index: number) => (
										<Typography scale="medium" weight="600">
											{row.internalId}
										</Typography>
									),
								},
								{
									label: 'options',
									weight: 5,
									render: (row: ExternalVehicle, index: number) => (
										<div className="display_flex flex_align_center flex_gap_xs">
											<Typography
												scale="medium"
												weight="400"
												textColor="neutral_900"
												className="text_center"
											>
												{row.description}
											</Typography>
										</div>
									),
								},
								{
									label: 'actions',
									weight: 5,
									render: (row: ExternalVehicle, index: number) => (
										<LightTooltip
											title={
												row.tile
													? `GPS asignado: ${row.tile.uuid}`
													: 'GPS sin asignar'
											}
										>
											<div className="display_flex flex_align_center flex_gap_xs">
												<GPS
													className={`dim_lg text_${
														row.tile ? 'green_300' : 'red_300'
													}`}
												/>
												<Typography scale="medium" weight="400" className="">
													{row.tile ? row.tile.uuid : 'GPS sin asignar'}
												</Typography>
											</div>
										</LightTooltip>
									),
								},
								{
									label: 'estado',
									weight: 2,
									render: (row: ExternalVehicle, index: number) => (
										<div
											className={`
								dso_chip_small flex_grow_1 
								bg_${
									ExternalVehicleStatusValues[row.status]?.color
								}_nocontrast text_neutral_0 flex_basis_0 overflow_hidden overflow_ellipsis text_center
								`}
										>
											{ExternalVehicleStatusValues[row.status]?.title ??
												row.status}
										</div>
									),
								},
							]}
						/>
					) : (
						<div className="flex_center dim_100_per">
							<Typography
								scale="heading4"
								weight="600"
								className="text_neutral_900 m_xl text_center"
							>
								Tus filtros no generaron resultados
							</Typography>
						</div>
					)}
				</div>

				<div className="display_flex flex_align_center flex_justify_between flex_footer bg_neutral_0 p_x_xxxl p_y_md">
					<Button
						scale="small"
						icon={<AddCircle />}
						className="w_30_per"
						onClick={() => setOpenEdit(true)}
					>
						Añadir vehículo
					</Button>
					<Pager
						totalPages={pages ?? 0}
						page={currentPage}
						setPage={setCurrentPage}
						count={count}
						className="w_fit"
					/>
				</div>
				{openEdit && (
					<EditExternalVehicle
						open={openEdit}
						setOpen={(value: boolean) => {
							setOpenEdit(value);
							setSelectedVehicle(undefined);
						}}
						setResult={setResult}
						values={selectedVehicle}
					/>
				)}
			</div>
		);
	};

	return renderContent();
}

export default ExternalVehicles;
